'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwTextField = require('../cwtextfield/CwTextField');

var _CwTextField2 = _interopRequireDefault(_CwTextField);

var _CwLabel = require('../cwlabel/CwLabel');

var _CwLabel2 = _interopRequireDefault(_CwLabel);

var _CwFilterList = require('./CwFilterList.scss');

var _CwFilterList2 = _interopRequireDefault(_CwFilterList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwFilterList = function (_React$Component) {
  (0, _inherits3.default)(CwFilterList, _React$Component);

  function CwFilterList(props) {
    (0, _classCallCheck3.default)(this, CwFilterList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CwFilterList.__proto__ || (0, _getPrototypeOf2.default)(CwFilterList)).call(this, props));

    _initialiseProps.call(_this);

    var _this$props = _this.props,
        defaultFilter = _this$props.defaultFilter,
        options = _this$props.options;

    _this.state = {
      // Filter text
      filter: defaultFilter,
      // Options which haven't been selected and match the filter text
      filteredOptions: _this.filterOptions(defaultFilter, options),
      // Values of <options> currently selected in the <select>
      selectedValues: []
    };
    return _this;
  }

  (0, _createClass3.default)(CwFilterList, [{
    key: 'makeLookup',
    value: function makeLookup(arr, prop) {
      if (!arr) {
        return {};
      }

      var lkup = {};
      for (var i = 0, l = arr.length; i < l; i++) {
        if (prop) {
          lkup[arr[i][prop]] = true;
        } else {
          lkup[arr[i]] = true;
        }
      }
      return lkup;
    }
  }, {
    key: 'getItemsByProp',
    value: function getItemsByProp(arr, prop, values) {
      var items = [];
      var found = 0;
      var valuesLookup = this.makeLookup(values);
      for (var i = 0, la = arr.length, lv = values.length; i < la && found < lv; i++) {
        var key = (typeof prop === 'undefined' ? 'undefined' : (0, _typeof3.default)(prop)) === undefined ? arr[i].id : arr[i][prop];
        if (valuesLookup[key]) {
          items.push(arr[i]);
          found++;
        }
      }
      return items;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // NOTE: Perform any magic you need when the filterlist re-mounts (i.e. after pod collapses then re-expands)
      if (this.props.onLoad) {
        this.props.onLoad();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {

      // Update visibile options in response to options or value
      // changing. Also update selected values after the re-render completes, as
      // one of the previously selected options may have been removed.
      if (nextProps.options !== this.props.options || nextProps.value !== this.props.value || nextProps.options.length !== this.props.options.length || nextProps.value.length !== this.props.value.length) {
        this.setState({
          filteredOptions: this.filterOptions(this.state.filter, nextProps.value, nextProps.options)
        }, this.updateSelectedValues);
      }
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.select.focus();
    }

    /**
     * Filters the visible array of options in the list based on
     * the filter.
     */


    /**
     * Update the filter and filter options and filter the list
     */


    /**
     * On 'Enter' key event clear out the state for filter and selectedValues
     * and fire off the onChange event for our selectedOptions.
     */


    /**
     * Update the selectedValues of the state based on what is
     * selected in the list
     */


    /**
     * Update the value (selected items) and clear out the states list
     * of selected because we already added it to the value.
     */

    /**
     * Handler for when the list loses focus
     */

    /**
     * Handler for when the list receives focus
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          filter = _state.filter,
          filteredOptions = _state.filteredOptions,
          selectedValues = _state.selectedValues;
      var _props = this.props,
          cwId = _props.cwId,
          disabled = _props.disabled,
          placeholder = _props.placeholder,
          size = _props.size,
          invalid = _props.invalid,
          readOnly = _props.readOnly,
          includeFilter = _props.includeFilter,
          listHeader = _props.listHeader;


      return _react2.default.createElement(
        'div',
        { 'data-cwid': cwId, className: _CwFilterList2.default.wrap },
        _react2.default.createElement(_CwLabel2.default, { value: listHeader, className: _CwFilterList2.default.header }),
        _react2.default.createElement(
          'select',
          { multiple: this.props.allowMultiSelect,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            className: this.props.invalid ? _CwFilterList2.default.listInvalid : _CwFilterList2.default.list,
            ref: function ref(select) {
              return _this2.select = select;
            },
            size: size,
            value: selectedValues,
            onChange: this.updateSelectedValues,
            onDoubleClick: this.addSelectedToSelection,
            disabled: disabled
          },
          filteredOptions.map(function (option) {
            return _react2.default.createElement(
              'option',
              { key: option.id, value: option.id },
              option.name
            );
          })
        ),
        includeFilter ? _react2.default.createElement(_CwTextField2.default, {
          className: this.props.invalid ? _CwFilterList2.default.filterInvalid : _CwFilterList2.default.filter,
          placeholder: placeholder,
          value: filter,
          invalid: invalid,
          readOnly: readOnly,
          disabled: disabled,
          onChange: this.onFilterChange,
          onKeyPress: this.onFilterKeyPress
        }) : null
      );
    }
  }]);
  return CwFilterList;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.filterOptions = function (filter, selectedOptions, options) {
    if (typeof filter == 'undefined') {
      filter = _this3.state.filter;
    }

    if (typeof selectedOptions == 'undefined') {
      selectedOptions = _this3.props.value;
    }

    if (typeof options == 'undefined') {
      options = _this3.props.options;
    }

    filter = filter.toUpperCase();

    var mapKey = _this3.props.mapKey;

    var selectedValueLookup = _this3.makeLookup(selectedOptions, mapKey);
    var filteredOptions = [];
    var optLength = typeof options == 'undefined' ? 0 : options.length;

    for (var i = 0, l = optLength; i < l; i++) {
      if (!selectedValueLookup[options[i].name] && (!filter || options[i].name.toUpperCase().indexOf(filter) !== -1)) {
        filteredOptions.push(options[i]);
      }
    }

    return filteredOptions;
  };

  this.onFilterChange = function (event) {
    var filter = event;
    _this3.setState({
      filter: filter,
      filteredOptions: _this3.filterOptions(filter)
    }, _this3.updateSelectedValues);
  };

  this.onFilterKeyPress = function (event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      if (_this3.state.filteredOptions.length === 1) {
        var selectedOption = _this3.state.filteredOptions[0];
        var selectedOptions = _this3.props.value.concat([selectedOption]);
        _this3.setState({ filter: '', selectedValues: [] }, function () {
          _this3.props.onChange(selectedOptions);
        });
      }
    }
  };

  this.updateSelectedValues = function (event) {
    var selection = event ? event.target : _this3.select;
    var selectedValues = [];
    for (var i = 0, l = selection.options.length; i < l; i++) {
      if (selection.options[i].selected) {
        selectedValues.push(selection.options[i].value);
      }
    }

    // Always update if we were handling an event, otherwise only update if
    // selectedValues has actually changed.
    if (event || String(_this3.state.selectedValues) !== String(selectedValues)) {
      _this3.setState({ selectedValues: selectedValues });
      _this3.props.onChange(selectedValues);
    }
  };

  this.addSelectedToSelection = function () {
    var selectedOptions = _this3.props.value.concat(_this3.getItemsByProp(_this3.state.filteredOptions, _this3.props.mapKey, _this3.state.selectedValues));
    _this3.setState({ selectedValues: [] }, function () {
      _this3.props.onChange(selectedOptions);
    });
  };

  this.onBlur = function () {
    /*istanbul ignore else*/
    if (_this3.props.onBlur) _this3.props.onBlur();
  };

  this.onFocus = function () {
    /*istanbul ignore else*/
    if (_this3.props.onFocus) _this3.props.onFocus();
  };
};

CwFilterList.propTypes = {
  /**
   * Callback function that is fired when filterlist's selection changes
   */
  onChange: _propTypes2.default.func,
  /**
   * Array of options to be listed in the dropdown menu. Must contain at least "id" and "name" fields.
   */
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.number,
    name: _propTypes2.default.string
  })),
  /**
   * Represents the item(s) that has been selected from the list.
   */
  value: _propTypes2.default.arrayOf(_propTypes2.default.number),
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes2.default.string,
  /**
   * Default text to display on filter
   */
  defaultFilter: _propTypes2.default.string,
  /**
   * Number of records to display in the list before scroll
   */
  size: _propTypes2.default.number,
  /**
   * Used to control if filterlist is valid
   */
  invalid: _propTypes2.default.bool,
  /**
   * Used to disable filterlist
   */
  disabled: _propTypes2.default.bool,
  /**
   * Used to set the inner text field to a read only mode
   */
  readOnly: _propTypes2.default.bool,
  /**
   * Allows the user to select multiple items at the same time
   */
  allowMultiSelect: _propTypes2.default.bool,
  /**
   * Place holder test for the filter box
   */
  placeholder: _propTypes2.default.string,
  /**
   * Boolean to render the filter or not
   */
  includeFilter: _propTypes2.default.bool,
  /**
   * Key for the filter map lookup used to filter the list by property
   */
  mapKey: _propTypes2.default.string,
  /**
   * Header to display above the list box
   */
  listHeader: _propTypes2.default.string,
  /**
   * focus handler
   */
  onFocus: _propTypes2.default.func,
  /**
   * blur handler
   */
  onBlur: _propTypes2.default.func
};

CwFilterList.defaultProps = {
  defaultFilter: '',
  size: 6,
  includeFilter: true,
  allowMultiSelect: true
};

exports.default = CwFilterList;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwfilterlist/CwFilterList.js
// module id = 369
// module chunks = 10